import { SUCCESS_SUFFIX, FAILURE_SUFFIX } from 'core/actions/apis';

const HeaderHolidayImageActionPath = 'core/HeaderHolidayImage';

export const HEADER_HOLIDAY_IMAGE_GET_SUCCESS = `${HeaderHolidayImageActionPath}/GET_${SUCCESS_SUFFIX}`;
export const HEADER_HOLIDAY_IMAGE_GET_FAILURE = `${HeaderHolidayImageActionPath}/GET_${FAILURE_SUFFIX}`;
